// ============================================================
// creationsModal.js — Modal "Mis creaciones"
// ------------------------------------------------------------
// Se abre desde el chip de adjunto del prompt box cuando el
// usuario pulsa "Mis creaciones". Permite seleccionar imágenes
// generadas previamente (hasta 14) y devolverlas al chip que
// disparó la apertura.
// ============================================================
import { qs, qsa, on } from './utils.js';
import { toast } from './toast.js';

const MAX_SELECTION = 14;

let modalEl = null;
let activeChip = null;          // chip que disparó la apertura
const selected = new Set();     // ids de creaciones seleccionadas

export function initCreationsModal() {
  modalEl = qs('#creationsModal');
  if (!modalEl) return;

  // Cerrar (X o clic fuera del diálogo)
  on(modalEl, 'click', '[data-action="creations-close"]', closeModal);

  // Toggle de selección
  on(modalEl, 'click', '.creation-thumb', (e, thumb) => {
    const id = thumb.dataset.creation;
    if (!id) return;

    if (selected.has(id)) {
      selected.delete(id);
      thumb.classList.remove('is-selected');
    } else {
      if (selected.size >= MAX_SELECTION) {
        toast({ message: `Máximo ${MAX_SELECTION} imágenes`, type: 'error' });
        return;
      }
      selected.add(id);
      thumb.classList.add('is-selected');
    }
    syncFooter();
  });

  // Confirmar y añadir al chip
  on(modalEl, 'click', '[data-action="creations-add"]', () => {
    if (selected.size === 0) return;
    applySelectionToChip();
    closeModal();
  });

  // Cerrar con Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modalEl.classList.contains('is-open')) {
      closeModal();
    }
  });
}

/**
 * Abre el modal. Recibe el chip que disparó la apertura para
 * poder devolverle las imágenes seleccionadas al confirmar.
 */
export function openCreationsModal(chip) {
  if (!modalEl) return;
  activeChip = chip || null;

  // Resetear selección previa
  selected.clear();
  qsa('.creation-thumb.is-selected', modalEl).forEach((t) => t.classList.remove('is-selected'));
  syncFooter();

  modalEl.classList.add('is-open');
  modalEl.setAttribute('aria-hidden', 'false');
  document.body.classList.add('has-modal-open');
}

function closeModal() {
  if (!modalEl) return;
  modalEl.classList.remove('is-open');
  modalEl.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('has-modal-open');
  activeChip = null;
}

function syncFooter() {
  const count = qs('[data-bind="creations-count"]', modalEl);
  if (count) count.textContent = selected.size;
  const addBtn = qs('[data-action="creations-add"]', modalEl);
  if (addBtn) addBtn.disabled = selected.size === 0;
}

function applySelectionToChip() {
  if (!activeChip) {
    toast({ message: `${selected.size} imagen(es) añadidas`, type: 'success' });
    return;
  }

  activeChip.classList.remove('is-hidden');
  activeChip.classList.add('has-file');

  const label = qs('[data-bind="attach-label"]', activeChip);
  if (label) {
    const n = selected.size;
    label.textContent = n === 1 ? '1 creación seleccionada' : `${n} creaciones seleccionadas`;
  }
  const icon = qs('.chip-main > i', activeChip);
  if (icon) icon.className = 'bi bi-image-fill';

  toast({ message: `${selected.size} imagen(es) añadidas desde Mis creaciones`, type: 'success' });
}
